export default "__VITE_ASSET__BB_ED7nO__"